export default "https://cdn-static.gokick.com/assets/81b7a47639310ad105c767144326fc68b25cbb5d/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";